<template>
    <div>
      <Loading :value="loading"></Loading>
      <v-layout row>
        <!-- <v-layout row xs12> -->
        <Loading :value="loading"></Loading>
        <v-dialog v-model="dialogAjoutConducteur" max-width="100%">
            <v-card>
            <v-toolbar dark color="primary">
                <v-toolbar-title>{{ libelleType }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="closeDialog()">
                <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>
    
            <!-- STAT DES INDICATEURS CLES PAR PROJETS -->
            <v-layout row class="mb-2" v-if="typeGraph === 'stat_projet'">
                <div id="bar-chart" class="chart"></div>
            </v-layout>
            <br />
            <br />
            <!-- COURBE DEVOLUTION DES MARGES -->
            <v-layout row class="mb-2" v-if="typeGraph === 'courbe_marge'">
                <div ref="chart" style="width: 100%; height: 400px;"></div>
            </v-layout>
            <br />
            <br />
            <!-- COURBE DEVOLUTION DES TRANSACTION DEBIT ET CREDIT -->
            <v-layout row class="mb-2" v-if="typeGraph === 'transactions'">
                <div ref="trans" style="width: 100%; height: 400px; position: relative;"></div>
            </v-layout>


            <data-tables
                            :data="listeData.projets"
                            style="width:100%;"
                        >
                            <!--expand liste classe comptable-->
                            <el-table-column type="expand">
                                <template slot-scope="props">
                                <el-row class="elevation-3 pl-4 pr-4 pt-2">
                                        <el-col :span="24">
                                        <div class="grid-content bg-purple mb-2">                      
                                            <div>
                                            <v-chip dark label color="purple" text-color="white">
                                                <v-icon left>label</v-icon>
                                                <span>LISTE PAR NUMERO DE COMPTE </span>
                                            </v-chip>                                        
                                            <data-tables
                                                ref="multipleTable"
                                                :data="props.row.marche"
                                                align="center"
                                                :summary-method="getSummCompteFinance"
                                                show-summary
                                                height="550"
                                                style="width:100%"
                                            >      
                                            

                                            <!--expand liste transaction-->
                                                <el-table-column type="expand">
                                                <template slot-scope="props">
                                                    <el-row class="elevation-3 pl-4 pr-4 pt-2">
                                                        <el-col :span="24">
                                                        <div class="grid-content bg-purple mb-2">                      
                                                            <div>
                                                                <v-chip dark label color="purple" text-color="white">
                                                                <v-icon left>label</v-icon>
                                                                <span>LISTE DES TRANSACTIONS</span>
                                                                </v-chip>
                                                            
                                                                <!-- <v-flex xs12 class="text-xs-right">
                                                                    <el-popover v-if="true"
                                                                        placement="top-start"
                                                                        title="MONTANT TOTAL HORS TAXE ENGAGÉ"
                                                                        width="500"
                                                                        trigger="hover"
                                                                        >
                                                                        <el-table :data="helpDemande">
                                                                            <el-table-column width="600" property="text" label=""></el-table-column>
                                                                        </el-table>
                                                                        <el-button v-if="true" style="font-size:25px" icon="el-icon-question" slot="reference"  type="text" ></el-button>
                                                                    </el-popover>
                                                                </v-flex> -->

                                                                <data-tables
                                                                ref="multipleTable"
                                                                :data="props.row.depenses"
                                                                align="center"
                                                                :summary-method="getSummCompteFinance"
                                                                show-summary
                                                                height="550"
                                                                style="width:100%"
                                                                >      
                                                                              
                                                                
                                                                <el-table-column
                                                                prop="date"
                                                                label="Date"
                                                                align="center"
                                                                width="300"
                                                                >
                                                                <template slot-scope="scope">
                                                                    <v-chip
                                                                    outline
                                                                    label
                                                                    text-color="primary"
                                                                    color="green"
                                                                    >{{ scope.row.date }}</v-chip
                                                                    >                            
                                                                </template>
                                                                </el-table-column>

                                                                <el-table-column
                                                                prop="libelleDepense"
                                                                label="Libellé de l'opération"
                                                                align="center"
                                                                width="300"
                                                                >
                                                                <template slot-scope="scope">
                                                                    <v-chip
                                                                    outline
                                                                    label
                                                                    text-color="primary"
                                                                    color="primary"
                                                                    >{{ scope.row.libelleDepense }}</v-chip
                                                                    >                            
                                                                </template>
                                                                </el-table-column>


                                                                <!-- <el-table-column
                                                                prop="typeCharge"
                                                                label="Type de charge"
                                                                align="center"
                                                                width="300"
                                                                >
                                                                <template slot-scope="scope">
                                                                    <v-chip
                                                                    outline
                                                                    label
                                                                    text-color="primary"
                                                                    color="green"
                                                                    >{{ scope.row.typeCharge }}</v-chip
                                                                    >                            
                                                                </template>
                                                                </el-table-column> -->
                                                                                
                                                                <el-table-column label="MOUVEMENTS" align="center">

                                                                    <el-table-column
                                                                        prop="montantD"
                                                                        label="DÉBITS"
                                                                    >
                                                                    <template slot-scope="scope">
                                                                    <v-chip

                                                                        text-color="white"
                                                                        label
                                                                        color="red"
                                                                    >{{ new Intl.NumberFormat().format(scope.row.montantD)}} </v-chip>

                                                                    </template>
                                                                </el-table-column>

                                                                <el-table-column
                                                                    prop="montantC"
                                                                    label="CRÉDITS"
                                                                    >

                                                                <template slot-scope="scope">
                                                                    <v-chip
                                                                    text-color="white"
                                                                    label
                                                                    color="green"
                                                                    >{{ new Intl.NumberFormat().format(scope.row.montantC)}} </v-chip>
                                                                </template>

                                                                </el-table-column>
                                                                
                                                            </el-table-column>
                                                    

                                                            <el-table-column label="SOLDES" align="center">
                                                                <el-table-column
                                                                    prop="soldeD"
                                                                    label="DÉBITEURS"
                                                                    >
                                                                    <template slot-scope="scope">
                                                                    <v-chip

                                                                    text-color="white"
                                                                    label
                                                                    color="red"
                                                                    >{{ new Intl.NumberFormat().format(scope.row.soldeD)}} </v-chip>

                                                                </template>
                                                                </el-table-column>

                                                                <el-table-column
                                                                    prop="soldeC"
                                                                    label="CRÉDITEURS"
                                                                >
                                                                <template slot-scope="scope">
                                                                <v-chip

                                                                    text-color="white"
                                                                    label
                                                                    color="green"
                                                                >{{ new Intl.NumberFormat().format(scope.row.soldeC)}} </v-chip>

                                                                </template>
                                                            </el-table-column>
                                                                
                                                            </el-table-column>
                                                    


                                                                </data-tables>
                                                                                                
                                                            </div>
                                                        </div>
                                                        </el-col>
                                                    </el-row>                                                                                                                      
                                                </template>
                                                </el-table-column>
                                            <!--expand-->

                                            <el-table-column
                                                prop="libelleCompte"
                                                label="NUMÉRO DE COMPTE"
                                                align="center"
                                                width="300"
                                            >
                                                <template slot-scope="scope">
                                                <v-chip
                                                    outline
                                                    label
                                                    text-color="primary"
                                                    color="primary"
                                                    >{{ scope.row.code }} {{ scope.row.libelleCompte }}</v-chip
                                                >                            
                                                </template>
                                            </el-table-column>
                                

                                            <el-table-column label="MOUVEMENTS" align="center">
                                                    <el-table-column
                                                    prop="totalMontantD"
                                                    label="DÉBIT"
                                                    >
                                                    <template slot-scope="scope">
                                                    <v-chip text-color="white" label color="red"
                                                    >{{
                                                        new Intl.NumberFormat().format(
                                                        scope.row.totalMontantD
                                                        )
                                                    }} XOF
                                                    </v-chip>
                                                </template>
                                                </el-table-column>

                                                    <el-table-column
                                                    prop="totalMontantC"
                                                    label="CRÉDIT"
                                                    >
                                                    <template slot-scope="scope">
                                                    <v-chip text-color="white" label color="green"
                                                    >{{
                                                        new Intl.NumberFormat().format(
                                                        scope.row.totalMontantC
                                                        )
                                                    }} XOF
                                                    </v-chip>
                                                </template>
                                                </el-table-column>
                                                
                                            </el-table-column>
                                        
                                            <el-table-column label="SOLDES" align="center">
                                                    <el-table-column
                                                    prop="totalSoldeD"
                                                    label="TOTAL DÉBITEURS"
                                                    >
                                                    <template slot-scope="scope">
                                                    <v-chip

                                                    text-color="white"
                                                    label
                                                    color="red"
                                                    >{{ new Intl.NumberFormat().format(scope.row.totalSoldeD)}}  XOF</v-chip>

                                                </template>
                                                </el-table-column>

                                                    <el-table-column
                                                    prop="totalSoldeC"
                                                    label="TOTAL CRÉDITEURS"
                                                    >
                                                    <template slot-scope="scope">
                                                    <v-chip

                                                    text-color="white"
                                                    label
                                                    color="green"
                                                    >{{ new Intl.NumberFormat().format(scope.row.totalSoldeC)}}  XOF</v-chip>

                                                </template>
                                                </el-table-column>
                                                
                                            </el-table-column>
                                
                                            <!-- <el-table-column label="CHARGES" align="center">
                                                    <el-table-column
                                                    prop="totalMontantD"
                                                    label="DIRECT"
                                                    >
                                                    <template slot-scope="scope">
                                                    <v-chip text-color="white" label color="primary"
                                                    >{{
                                                        new Intl.NumberFormat().format(
                                                        scope.row.totalMontantD
                                                        )
                                                    }} XOF
                                                    </v-chip>
                                                </template>
                                                </el-table-column>

                                                    <el-table-column
                                                    prop="totalMontantC"
                                                    label="INDIRECTE"
                                                    >
                                                    <template slot-scope="scope">
                                                    <v-chip text-color="white" label color="info"
                                                    >{{
                                                        new Intl.NumberFormat().format(
                                                        scope.row.totalMontantC
                                                        )
                                                    }} XOF
                                                    </v-chip>
                                                </template>
                                                </el-table-column>
                                                
                                            </el-table-column> -->

                                            </data-tables>
                                                                                
                                            </div>
                                        </div>
                                        </el-col>
                                    </el-row>                                                                                                                      
                                </template>
                            </el-table-column>
                        <!--expand-->
            
                            <el-table-column
                            prop="libelleProjet"
                            label="LIBELLÉ PROJET"
                            align="center"
                            width="300"
                            >
                            <template slot-scope="scope">
                                <v-chip
                                outline
                                label
                                text-color="primary"
                                color="primary"
                                >{{ scope.row.libelleProjet }}</v-chip
                                >                            
                            </template>
                            </el-table-column>
                        
                            <el-table-column v-if="!hideInterface" label="EVOLUTION PHYSIQUE" align="center">
                                <template slot-scope="scope">
                                <v-progress-circular
                                    :size="80"
                                    :width="15"
                                    :rotate="360"
                                    :value="scope.row.evolution"
                                    color="orange"
                                    >{{
                                    scope.row.evolution
                                    }}
                                    %</v-progress-circular
                                >
                                </template>
                            </el-table-column>
                            
                            
                                <el-table-column v-if="!hideInterface" 
                                label="MONTANT DU MARCHE "
                                align="center"
                                >
                                <template slot-scope="scope">
                                    <v-chip text-color="white" label color="blue"
                                    >{{
                                        new Intl.NumberFormat().format(
                                        scope.row.montantMarche
                                        )
                                    }}
                                    </v-chip>
                                </template>
                                </el-table-column>

                                <el-table-column v-if="!hideInterface" 
                                label="BUDGET ESTIMATIF "
                                align="center"
                                >
                                <template slot-scope="scope">
                                <v-chip
                                    text-color="white"
                                    label
                                    color="green"
                                    >{{ 
                                    new Intl.NumberFormat().format(
                                        scope.row.budget
                                        )  }}</v-chip
                                >
                                </template>
                            </el-table-column>

                            <el-table-column label="MOUVEMENTS" align="center">
                                    <el-table-column
                                    prop="chargeDirect"
                                    label="DÉBIT"
                                    >
                                    <template slot-scope="scope">
                                    <v-chip text-color="white" label color="red"
                                    >{{
                                        new Intl.NumberFormat().format(
                                        scope.row.montantD
                                        )
                                    }} XOF
                                    </v-chip>
                                </template>
                                </el-table-column>

                                    <el-table-column
                                    prop="chargeIndirect"
                                    label="CRÉDIT"
                                    >
                                    <template slot-scope="scope">
                                    <v-chip text-color="white" label color="green"
                                    >{{
                                        new Intl.NumberFormat().format(
                                        scope.row.montantC
                                        )
                                    }} XOF
                                    </v-chip>
                                </template>
                                </el-table-column>
                                
                            </el-table-column>                    


                            <el-table-column label="SOLDES" align="center">
                                    <el-table-column
                                    prop="soldeDebit"
                                    label="DÉBITEURS"
                                    >
                                    <template slot-scope="scope">
                                    <v-chip

                                    text-color="white"
                                    label
                                    color="red"
                                    >{{ new Intl.NumberFormat().format(scope.row.soldeDebit)}} XOF</v-chip>

                                </template>
                                </el-table-column>

                                    <el-table-column
                                    prop="soldeCredit"
                                    label="CRÉDITEURS"
                                    >
                                    <template slot-scope="scope">
                                    <v-chip

                                    text-color="white"
                                    label
                                    color="green"
                                    >{{ new Intl.NumberFormat().format(scope.row.soldeCredit)}} XOF </v-chip>

                                </template>
                                </el-table-column>
                                
                            </el-table-column>

                            <!-- <el-table-column label="CHARGES" align="center">
                                    <el-table-column
                                    prop="chargeDirect"
                                    label="DIRECT"
                                    >
                                    <template slot-scope="scope">
                                    <v-chip text-color="white" label color="primary"
                                    >{{
                                        new Intl.NumberFormat().format(
                                        scope.row.chargeDirect
                                        )
                                    }} XOF
                                    </v-chip>
                                </template>
                                </el-table-column>

                                    <el-table-column
                                    prop="chargeIndirect"
                                    label="INDIRECTE"
                                    >
                                    <template slot-scope="scope">
                                    <v-chip text-color="white" label color="info"
                                    >{{
                                        new Intl.NumberFormat().format(
                                        scope.row.chargeIndirect
                                        )
                                    }} XOF
                                    </v-chip>
                                </template>
                                </el-table-column>
                                
                            </el-table-column> -->
                    
                            <el-table-column label="MARGE"  v-if="!hideInterface" align="center">
                                <template slot-scope="scope">
                                    <v-chip

                                    text-color="white"
                                    label
                                    color="orange"
                                    >{{ new Intl.NumberFormat().format(scope.row.marge)}} XOF</v-chip>

                                </template>
                            </el-table-column>    
                            
            </data-tables>


    
            <v-card-text>
                <v-layout row>
                <v-flex xs12></v-flex>
                </v-layout>
    
                <v-layout row>
                <v-flex xs12 class="text-xs-right">
                    <v-btn @click="closeDialog()" color="orange" dark>
                    Annuler <v-icon right>close</v-icon>
                    </v-btn>
                </v-flex>
                </v-layout>
            </v-card-text>
            </v-card>
        </v-dialog>
        <!-- </v-layout> -->
    </v-layout>
</div>
  </template>
  
  <script>
  import Loading from "@/components/Loading";
  import 'echarts/lib/chart/bar';
  import 'echarts/lib/chart/pie';
  import 'echarts/lib/component/tooltip';
  import 'echarts/lib/component/title';
  import * as echarts from 'echarts';
  import ECharts from 'vue-echarts';
  import 'echarts/lib/chart/line';
  
  export default {
    name: "LoadShowGraph",
    components: {
      Loading,
      'v-chart': ECharts
    },
    props: {
      listeData: {
        type: Array,
        default: null
      },
      show: {
        type: Boolean,
        default: false
      },
      typeGraph: {
        type: String
      }
    },
    data() {
      return {
        domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
        user: JSON.parse(sessionStorage.getItem("userInfo")),
        roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
        droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
        dialogAjoutConducteur: false,
        loading: false,
        libelleType: '',
        chart: null,
        hideInterface: true
      };
    },
    watch: {
      show: async function(newValue, oldValue) {
        if (newValue === true) {
          this.dialogAjoutConducteur = true;
          
          // Attendre que le dialogue soit monté
          await this.$nextTick();
          
          if (this.typeGraph === 'transactions') {
            this.libelleType = "Détails des informations sur le graphique des états des transactions";
            if (this.listeData && this.listeData.stackedLinData) {
                this.hideInterface = false;
              this.initLineChart(this.listeData.stackedLinData);
            }
          }
          if (this.typeGraph === 'courbe_marge') {
            this.libelleType = "Détails des informations sur le graphique des courbes d'évolution des marges";
            if (this.listeData && this.listeData.barChartData) {
              this.initChart(this.listeData.barChartData);
            }
          }
          if (this.typeGraph === 'stat_projet') {
            this.libelleType = "Détails des informations sur le graphique des statistiques du projet";
            if (this.listeData && this.listeData.barChartData) {
              this.initBarChart(this.listeData.barChartData);
            }
          }
        } else {
          this.dialogAjoutConducteur = false;
          window.location.reload();
        }
      }
    },
    methods: {
      async initLineChart(row) {
        await this.$nextTick();
        
        if (!this.$refs.trans) {
          console.error("L'élément de référence 'trans' n'existe pas");
          return;
        }
  
        try {
          this.chart = echarts.init(this.$refs.trans);
          // Formatage des données pour une meilleure lisibilité
            const formatNumber = (value) => {   
              return value.toString();
            };
          const options = {
            title: {
              text: "Etat des transactions des projets (Débit / Crédit)",     
              left: "left",
              subtextStyle: {
                color: "#007BFF",
                fontSize: 14,
                cursor: "pointer",
                fontWeight: "bold",
                width: 200,
                overflow: 'break'
              },
              triggerEvent: true
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: 'cross'
              },
              formatter: function(params) {
                let result = params[0].axisValue + '<br/>';
                params.forEach(param => {
                  result += param.marker + param.seriesName + ': ' + 
                  new Intl.NumberFormat().format(formatNumber(param.value)) + ' XOF<br/>';
                });
                return result;
              }
            },
            legend: {
              data: ["Débit", "Crédit"],
              top: '50px'
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            dataZoom: [
              {
                type: 'inside',
                start: 0,
                end: 100
              },
              {
                start: 0,
                end: 100
              }
            ],
            xAxis: {
              type: "category",
              boundaryGap: false,
              data: row.mois,
              axisLabel: {
                rotate: 45
              }
            },
            yAxis: [
              {
                type: "value",
                name: "Débit",
                position: 'left',
                axisLabel: {
                  formatter: value =>   new Intl.NumberFormat().format( formatNumber(value) )+ ' XOF'
                },
                axisLine: {
                  show: true,
                  lineStyle: {
                    color: '#ff4d4f'
                  }
                }
              },
              {
                type: "value",
                name: "Crédit",
                position: 'right',
                axisLabel: {
                  formatter: value =>    new Intl.NumberFormat().format( formatNumber(value) ) + ' XOF'
                },
                axisLine: {
                  show: true,
                  lineStyle: {
                    color: '#52c41a'
                  }
                }
              }
            ],
            series: [
              {
                name: "Débit",
                type: "line",
                data: row.debit, // Prend la première valeur de chaque tableau
                yAxisIndex: 0,
                symbol: 'circle',
                symbolSize: 8,
                lineStyle: {
                  color: '#ff4d4f',
                  width: 3
                },
                itemStyle: {
                  color: '#ff4d4f'
                },
                areaStyle: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: 'rgba(255,77,79,0.3)' },
                    { offset: 1, color: 'rgba(255,77,79,0.1)' }
                  ])
                }
              },
              {
                name: "Crédit",
                type: "line",
                data: row.credit,
                yAxisIndex: 1,
                symbol: 'circle',
                symbolSize: 8,
                lineStyle: {
                  color: '#52c41a',
                  width: 3
                },
                itemStyle: {
                  color: '#52c41a'
                },
                areaStyle: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: 'rgba(82,196,26,0.3)' },
                    { offset: 1, color: 'rgba(82,196,26,0.1)' }
                  ])
                }
              }
            ]
           };
          this.chart.setOption(options);
          
          // Gérer le redimensionnement
          window.addEventListener('resize', this.handleResize);
          
        } catch (error) {
          console.error('Erreur lors de l\'initialisation du graphique:', error);
        }
      },
  
      async initBarChart(row) {
        await this.$nextTick();
        
        const element = document.getElementById('bar-chart');
        if (!element) {
          console.error("L'élément 'bar-chart' n'existe pas");
          return;
        }
  
        try {
          this.chart = echarts.init(element);
          const options = {
              title: {
                text: "Statistiques des indicateurs clés des projets",
                left: "left",
                subtextStyle: {
                  color: "#007BFF",
                  fontSize: 14,
                  cursor: "pointer",
                  fontWeight: "bold"
                },
                // Activer les événements sur le sous-titre
                triggerEvent: true
              },
              tooltip: {
                trigger: "axis",
                axisPointer: { type: "shadow" }
              },
              legend: {
                data: [
                  "Montant du marché",
                  "Budget total",
                  "Montant encaissé",
                  "Montant décaissé"
                ],
                bottom: 0
              },
              xAxis: {
                type: "category",
                data:  row.projects.map(project => project.substring(0, 5))
              },
              yAxis: {
                type: "value"
              },
              color: ["#5470C6", "#8e6e63", "#d3302f", "#378f3c"], // Palette de couleurs
              series: [
                {
                  name: "Montant du marché",
                  type: "bar",
                  data: row.montantMarche,
                  itemStyle: { color: "#5470C6" } // Couleur spécifique
                },
                {
                  name: "Budget total",
                  type: "bar",
                  data: row.budgetTotal,
                  itemStyle: { color: "#8e6e63" } // Couleur spécifique
                },
                {
                  name: "Montant décaissé",
                  type: "bar",
                  data: row.montantDecaisse,
                  itemStyle: { color: "#d3302f" } // Couleur spécifique
                },
                {
                  name: "Montant encaissé",
                  type: "bar",
                  data: row.montantEncaisse,
                  itemStyle: { color: "#378f3c" } // Couleur spécifique
                }
              ]
          };
  
          this.chart.setOption(options);
          window.addEventListener('resize', this.handleResize);
        } catch (error) {
          console.error('Erreur lors de l\'initialisation du graphique:', error);
        }
      },
  
      async initChart(row) {
        await this.$nextTick();
        
        if (!this.$refs.chart) {
          console.error("L'élément de référence 'chart' n'existe pas");
          return;
        }
  
        try {
          this.chart = echarts.init(this.$refs.chart);
          const options = {
              title: {
                text: "Courbe d'évolution des marges et du taux d'évolution physique",
                left: "left",
                subtextStyle: {
                  color: "#007BFF",
                  fontSize: 14,
                  cursor: "pointer",
                  fontWeight: "bold"
                },
                triggerEvent: true
              },

              tooltip: {
                trigger: "axis",
                axisPointer: {
                  type: "cross"
                },
                formatter: function(params) {
                  let result = params[0].axisValueLabel + "<br/>";
                  params.forEach(param => {
                    // Formater selon le type de donnée
                    const value =
                      param.seriesName === "Taux physique"
                        ? param.value + "%"
                        : param.value.toLocaleString() + " XOF";
                    result +=
                      param.marker + param.seriesName + ": " + value + "<br/>";
                  });
                  return result;
                }
              },
              legend: {
                data: ["Marge", "Taux physique"]
              },
              grid: {
                left: "3%",
                right: "4%",
                bottom: "3%",
                containLabel: true
              },
              toolbox: {
                feature: {
                  saveAsImage: {}
                }
              },
              xAxis: {
                type: "category",
                boundaryGap: false,
                data: row.projects.map(project => project.substring(0, 5))
              },
              yAxis: [
                {
                  type: "value",
                  name: "Marge (XOF)",
                  position: "left",
                  axisLine: {
                    show: true,
                    lineStyle: {
                      color: "#4CAF50"
                    }
                  },
                  axisLabel: {
                    formatter: "{value} XOF"
                  }
                },
                {
                  type: "value",
                  name: "Taux physique (%)",
                  position: "right",
                  axisLine: {
                    show: true,
                    lineStyle: {
                      color: "#1976D2"
                    }
                  },
                  axisLabel: {
                    formatter: "{value} %"
                  },
                  splitLine: {
                    show: false
                  }
                }
              ],
              series: [
                {
                  name: "Marge",
                  type: "line",
                  smooth: true,
                  yAxisIndex: 0, // Utilise le premier axe Y
                  data: row.marges,
                  lineStyle: {
                    color: "#4CAF50",
                    width: 3
                  },
                  itemStyle: {
                    color: "#4CAF50"
                  },
                  symbol: "circle",
                  symbolSize: 8
                },
                {
                  name: "Taux physique",
                  type: "line",
                  yAxisIndex: 1, // Utilise le second axe Y
                  smooth: true,
                  data: row.taux,
                  lineStyle: {
                    color: "#1976D2",
                    width: 3
                  },
                  itemStyle: {
                    color: "#1976D2"
                  },
                  symbol: "circle",
                  symbolSize: 8
                }
              ]
            };
  
          this.chart.setOption(options);
          window.addEventListener('resize', this.handleResize);
        } catch (error) {
          console.error('Erreur lors de l\'initialisation du graphique:', error);
        }
      },
  
      handleResize() {
        if (this.chart) {
          this.chart.resize();
        }
      },
  
      closeDialog() {
        if (this.chart) {
          this.chart.dispose();
        }
        this.$emit("close");
      }
    },
    beforeDestroy() {
      if (this.chart) {
        this.chart.dispose();
        window.removeEventListener('resize', this.handleResize);
      }
    }
  };
  </script>
  
  <style scoped>
  .charts-section {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }
  
  .chart {
    width: 100%;
    height: 300px;
    background: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
  }
  
  #chart-container {
    width: 100%;
    height: 500px;
  }
  </style>


// WEBPACK FOOTER //
// src/components/projet/LoadShowGraph.vue